import { useState } from 'react';

import MainUserPricingSection from 'components/pricing/MainUserPricingSection';
import SubUserPricingSection from 'components/pricing/SubUserPricingSection';
import useTranslation from 'customHooks/translate';

type PaymentTab = 'mainUser' | 'subUsers';

const Payment = () => {
  const translation = useTranslation();
  const [activeTab, setActiveTab] = useState<PaymentTab>('mainUser');

  const isMainUser = activeTab === 'mainUser';

  return (
    <div>
      <h1 className="mb-[24px] text-[20px] font-semibold md:text-[24px]">
        {translation.profile.payment}
      </h1>

      <div className="mb-[24px] grid w-full grid-cols-[repeat(auto-fit,minmax(100px,1fr))] items-center rounded-[8px] bg-gray-100 p-[2px] md:flex md:w-fit">
        <button
          type="button"
          onClick={() => setActiveTab('mainUser')}
          className={`rounded-[6px] px-[20px] py-[8px] text-[14px] transition-all ${
            isMainUser ? 'bg-green-600 text-white' : 'text-[#1D1D1D]'
          }`}
        >
          {translation.profile.mainUser}
        </button>

        <button
          type="button"
          onClick={() => setActiveTab('subUsers')}
          className={`rounded-[6px] px-[20px] py-[8px] text-[14px] transition-all ${
            !isMainUser ? 'bg-green-600 text-white' : 'text-black'
          }`}
        >
          {translation.profile.subUsers}
        </button>
      </div>

      {isMainUser ? (
        <MainUserPricingSection />
      ) : (
        <SubUserPricingSection />
      )}
    </div>
  );
};

export default Payment;
